import useTranslation from "next-translate/useTranslation";
import { FaUser } from "react-icons/fa";
import { useSiteData } from "../../redux/siteData";
import { useWsConnection } from "../../redux/wsConnection";
import { getConnectionBlockedMessageKey } from "../../services/websocketRejection";

export default function PlayersOnline() {
  const { playersOnline } = useSiteData();
  const { wsConnected, connectionBlockedReason } = useWsConnection();
  const { t } = useTranslation("common");
  const hasPlayerCount = wsConnected && Number.isFinite(playersOnline);

  return (
    <div
      className="flex items-center justify-center w-full pt-3 pb-0 space-x-1 text-xs text-altgray-600"
      aria-live="polite"
    >
      <FaUser aria-hidden="true" />
      {connectionBlockedReason ? (
        <div className="px-3 text-center text-red-600">
          {t(getConnectionBlockedMessageKey(connectionBlockedReason))}
        </div>
      ) : hasPlayerCount ? (
        <>
          <div className="font-semibold">{playersOnline}</div>
          <div>{t("PLAYERS ONLINE")}</div>
        </>
      ) : (
        <div>{t("Reconnecting")}</div>
      )}
    </div>
  );
}
